import { Controller } from "@hotwired/stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ["input"];
  static values = { maxQuantity: Number };

  connect() {}

  minus() {
    let input = this.inputTarget;
    if (input.value > 0) {
      input.value = parseInt(input.value) - 1;
      this.submit();
    }
  }

  plus() {
    let input = this.inputTarget;
    if (
      this.maxQuantityValue == 0 ||
      (this.maxQuantityValue > 0 && input.value < this.maxQuantityValue)
    ) {
      input.value = parseInt(input.value) + 1;
      this.submit();
    }
  }

  setValue(event) {
    console.log("setValue", event.currentTarget);
    this.inputTarget.value = parseInt(event.currentTarget.dataset.value);
    this.submit();
  }

  submit() {
    Rails.fire(this.element, "submit");
  }
}
